var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 2.99993H4.1C2.83988 2.99993 2.20982 2.99993 1.72852 3.24516C1.30516 3.46088 0.96095 3.80508 0.745235 4.22845C0.5 4.70975 0.5 5.33981 0.5 6.59993V12.8999C0.5 14.16 0.5 14.7901 0.745235 15.2714C0.96095 15.6948 1.30516 16.039 1.72852 16.2547C2.20982 16.4999 2.83988 16.4999 4.1 16.4999H10.4C11.6601 16.4999 12.2902 16.4999 12.7715 16.2547C13.1948 16.039 13.539 15.6948 13.7548 15.2714C14 14.7901 14 14.16 14 12.8999V9.74993M4.99998 11.9999H6.25589C6.62277 11.9999 6.80622 11.9999 6.97885 11.9585C7.1319 11.9217 7.27822 11.8611 7.41243 11.7789C7.5638 11.6861 7.69352 11.5564 7.95294 11.297L15.125 4.12493C15.7463 3.50361 15.7463 2.49625 15.125 1.87493C14.5037 1.25361 13.4963 1.25361 12.875 1.87492L5.70293 9.04698C5.4435 9.30641 5.31378 9.43612 5.22102 9.5875C5.13878 9.72171 5.07817 9.86802 5.04143 10.0211C4.99998 10.1937 4.99998 10.3772 4.99998 10.744V11.9999Z",
    stroke: "#80859D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.519924b7c87b261c3a35d27182034ad3f3bb598d9f908f152b042174f57f32e5.svg";
export { ForwardRef as ReactComponent };